import React, { useState } from 'react';
import proptypes from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';

const { string } = proptypes;

export const SyndicationContent = ({ 
  logoImageUrl = null,
  name 
}) => {
  const [imageHasError, setImageHasError] = useState(false);

  if (!name) {
    return null;
  }

  const handleImageError = () => {
    setImageHasError(true);
  };

  return (
    <>
      {logoImageUrl && !imageHasError && (
        <Image
          src={logoImageUrl}
          alt={`${name} logo`}
          lazy
          onError={handleImageError}
        />
      )}
      Customer review from {name}
    </>
  );
};

SyndicationContent.displayName = 'SyndicationContent';

SyndicationContent.propTypes = {
  logoImageUrl: string,
  name: string.isRequired
};
